import BaseApi from "./baseAPI";

class QuizAPI extends BaseApi{
  get entity() {
    return {
      route: `${this.getCourseId()}/quizzes`,
      name: 'الإختبار'
    }
  }

  getQuizCorrection(id){
    return new Promise((resolve, reject) => {
      return this.request.get(`${this.entity.route}/${id}/correction`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  correctQuiz(id, student_id, data){
    return new Promise((resolve, reject) => {
      return this.request.put(`${this.entity.route}/${id}/correction/${student_id}`, data)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  saveStudentsQuiz(id, data){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/${id}/student_quizzes`, data)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  answerQuestion(quiz_id, data) {
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/${quiz_id}/answer_question`, data)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  confirmQuiz(id){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/${id}/confirm`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

}

export default new QuizAPI()
